import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { useEntityIdParam } from '../../hooks/useEntityIdParam';
import { useSMLDatePickerDateParam } from '../../hooks/useSMLDatePickerDateParam';
import { useCanViewListeningInsights } from '../../hooks/useCanViewListeningInsights';
import { useTrackListeningScoreChart } from '../../hooks/useTrackListeningScoreChart';
import { ListeningScoreChart } from '../ListeningScoreChart/ListeningScoreChart';

const TrackListeningScoreChartComponent: React.FC = () => {
  const intl = useIntl();
  const trackId = useEntityIdParam('track');
  const { selectedDate, rangeDays } = useSMLDatePickerDateParam();
  const canViewListeningInsights = useCanViewListeningInsights();

  const { data, isLoading, error } = useTrackListeningScoreChart({
    trackId: trackId || '',
    date: selectedDate,
    rangeDays,
    enabled: canViewListeningInsights,
  });

  const chartData = React.useMemo(() => data?.data ?? [], [data?.data]);

  return (
    <ListeningScoreChart
      title={intl.formatMessage({ id: 'app.sml.track.details.listening-score', defaultMessage: 'Listening Score' })}
      data={chartData}
      isLoading={isLoading}
      error={error}
      emptyLabel={intl.formatMessage({
        id: 'app.sml.track.details.listening-score.empty',
        defaultMessage: 'No listening data yet',
      })}
      errorLabel={intl.formatMessage({ id: 'app.sml.common.error', defaultMessage: 'Error' })}
    />
  );
};

export const TrackListeningScoreChart = TypedMemo(TrackListeningScoreChartComponent);
